export default class Cache {
  constructor() {
    this.data = new Map();
  }

  set(key, item, exp) {
    this.data.set(key, {
      item,
      exp: (new Date()).getTime() + exp,
    });
  }

  has(key) {
    return this.data.has(key);
  }

  get(key) {
    if (!this.has(key)) {
      return null;
    }
    const { item, exp } = this.data.get(key);
    if (exp <= (new Date()).getTime()) {
      this.data.delete(key);
      return null;
    }
    return item;
  }

  unset(key) {
    if (this.data.has(key)) {
      this.data.delete(key);
    } else {
      Array.from(this.data.keys()).forEach(cacheKey => {
        if (cacheKey.startsWith(key)) {
          this.data.delete(cacheKey);
        }
      });
    }
  }

  clear() {
    this.data.clear();
  }
}

export const cacheKey = (key) => {
  if (typeof key === 'object') {
    const json = JSON.stringify(key);
    let i, hash = 0;
    for (i = 0; i < json.length; i++) {
      var charCode = json.charCodeAt(i);
      hash = ((hash<<5)-hash) + charCode;
      hash = hash & hash;
    }
    return hash;
  } else {
    return String(key);
  }
};